import { HStack, IconButton, Link, Text, VStack, Box } from "@chakra-ui/react";
import { useState, useRef } from "react";
import { BsHeart } from "react-icons/bs";
import { Tooltip } from "@chakra-ui/react";
import { Skeleton, SkeletonCircle, SkeletonText } from '@chakra-ui/react'

const SkeletonCard = ({
  num,
}) => {

    const arr = useRef(new Array(8).fill(0));

  return (
    <Box
      m={"0.5rem"}
      boxShadow="rgba(0, 0, 0, 0.04) 0px 3px 5px"
      p={"0.5rem"}
    >
      <Box width={num === 2 ? "400px" : num === 3 ? "300px" : "full"} >
          <Skeleton
            className="image"
            alt="normal"
            width='80%'
            margin='auto'
            height={"280px"}
            
          >
          </Skeleton>


          <SkeletonText width='80%' margin='30px auto' ></SkeletonText>
      </Box>
    </Box>
  );
};



export { SkeletonCard };
